import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
//Leave it alone
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';
import createStore from './store';
import LazyLoad from './directives/LazyLoad.js';
import LogoutHandler from './helpers/logout-handler';

import { SET_AUTHENTICATION_TOKEN, AUTHENTICATE, IS_AUTHENTICATED, GET_USER, IS_LOADING } from './store/store-models/authentication-model';
import { SET_SHOW_MOBILE_MENU, SET_SHOW_COMPANY_HEADER } from './store/store-models/app-model';


import createRouter from './router';
import { sync } from 'vuex-router-sync';

const isProd = process.env.NODE_ENV === 'production'
const googleAnalyticsId = process.env.GOOGLE_ANALYTICS_ID

Vue.use(VTooltip);

export const EventBus = new Vue();

export async function createApp (ssrContext, registerAsyncData, extraComponents) {
    const store = createStore();
    const router = createRouter();

    const authenticationToken = ssrContext ? ssrContext.cookies['authentication_token'] : window.$cookies.get('authentication_token');
    const userData = ssrContext ? ssrContext.cookies['userData'] : window.$cookies.get('userData');

    store.commit(SET_AUTHENTICATION_TOKEN, { authenticationToken });
    try {
        await store.dispatch(AUTHENTICATE, userData);
    }
    catch(e){}

    LogoutHandler(store);

    sync(store, router);

    // Vue.use(VueAnalytics, {
    //   id: googleAnalyticsId,
    //   router,
    //   //disableScriptLoader: true,
    //   debug: {
    //     enabled: !isProd,
    //     sendHitTask: isProd,
    //   },
    // })

    router.beforeEach(async (to, from, next) => {
        const requiresAuth = to.meta.requiresAuth;
        const requiredRole = to.meta.role;
        const isAuthenticated = store.getters[IS_AUTHENTICATED];
        const isLoading = store.getters[IS_LOADING];
        store.commit(SET_SHOW_MOBILE_MENU, false);

        if (to.name === 'Hem (Hantverkare)') {
            store.commit(SET_SHOW_COMPANY_HEADER, true);
        } else if (to.name === 'Hem') {
            store.commit(SET_SHOW_COMPANY_HEADER, false);
        }

        if(requiresAuth) {
            const redirect = to.meta.redirect;
            const userData = store.getters[GET_USER];

            if (isLoading) {
                let awaitLoading = new Promise( (resolve) => {
                    store.watch( (state) => {
                        return state.authentication.isLoading;
                    }, (oldValue, newValue) => {
                        resolve();
                    });
                })

                await awaitLoading;
            }

            if(isAuthenticated && Object.keys(userData).length > 0) {
                return requiredRole.includes(userData.role) ? next() : next({path: redirect});
            }

            if (!isAuthenticated && !Object.keys(userData).length > 0) {
                return requiredRole.includes('Guest') ? next() : next({path: redirect});
            }
        }

        return next();
    })

    const app = new Vue({
        router,
        store,
        ssrContext,
        render: h => h(App),
        async asyncData ({ store, route }) {
            // recursive query sub components
            const recursive = (component) => {
                if (component.asyncData) registerAsyncData(component.asyncData);
                if (component.components) {
                    Object.keys(component.components).forEach(key => {
                        recursive(component.components[key]);
                    });
                }
            };
            recursive(App);

            return Promise.resolve();
        },
    });
    return {
        app,
        router,
        store
    };
};



// WEBPACK FOOTER //
// ./src/main.js